import type { Session } from '@cobliteam/common-types';
import useCameraFleetFlag from '@cobliteam/hooks/src/useCamera/useCameraFleetFlag';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

const Flags = ({ session }: { session: Session }) => {
  const queryClient = useQueryClient();

  const { getFleetPremiumPackageFlag, FLEET_FLAG_QUERY_KEY: fleetFlagQueryKey } = useCameraFleetFlag();
  const { data: isPremium } = getFleetPremiumPackageFlag();
  const [isPremiumSelected, setIsPremiumSelected] = useState<boolean>(isPremium || false);

  const handlePremiumChange = (checked: boolean) => {
    queryClient.setQueryData([fleetFlagQueryKey, session.fleet.id, 'FLEET_PRODUCTS_FLAG'], {
      products: [{ id: '', name: checked ? 'PREMIUM' : 'BASIC' }],
    });
  };

  useEffect(() => {
    handlePremiumChange(isPremiumSelected);
  }, [isPremiumSelected]);

  return (
    <div>
      <h3 className='font-semibold text-lg'>Flags</h3>
      <div className='mt-4'>
        <label className='flex items-center gap-2'>
          <input type='checkbox' checked={isPremiumSelected} onChange={(e) => setIsPremiumSelected(e.target.checked)} />
          Premium
        </label>
      </div>
    </div>
  );
};

export default Flags;
